"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Bar = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex justify-content-center align-items-center",
    id: "bar"
  };
}).withConfig({
  displayName: "CountdownClockProgressBar__Bar",
  componentId: "sc-1o5c7ag-0"
})(["position:absolute;background-color:", ";width:100%;border-radius:20px;height:50px;z-index:auto;"], function (props) {
  return props.styles.barColor;
});

var CountDownHolder = _styledComponents["default"].div.withConfig({
  displayName: "CountdownClockProgressBar__CountDownHolder",
  componentId: "sc-1o5c7ag-1"
})(["&&&{z-index:4;height:50px;width:300px;position:sticky;}"]);

var StyledIconHolder = _styledComponents["default"].div.withConfig({
  displayName: "CountdownClockProgressBar__StyledIconHolder",
  componentId: "sc-1o5c7ag-2"
})(["&&&{z-index:6;}"]);

var Progress = _styledComponents["default"].div.withConfig({
  displayName: "CountdownClockProgressBar__Progress",
  componentId: "sc-1o5c7ag-3"
})(["position:absolute;z-index:5;width:", ";height:50px;background-color:", ";border-radius:20px;"], function (props) {
  return props.percent + "%";
}, function (props) {
  return props.styles;
});

var Time = _styledComponents["default"].div.withConfig({
  displayName: "CountdownClockProgressBar__Time",
  componentId: "sc-1o5c7ag-4"
})(["z-index:6;font-size:30px;font-weight:bold;text-align:center;color:white;"]);

var CountdownClockProgressBar = function CountdownClockProgressBar(_ref) {
  var endDate = _ref.endDate,
      startDate = _ref.startDate,
      styles = _ref.styles;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      days = _useState2[0],
      setDays = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      hours = _useState4[0],
      setHours = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      minutes = _useState6[0],
      setMinutes = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      seconds = _useState8[0],
      setSeconds = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      progressPercent = _useState10[0],
      setProgress = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isDone = _useState12[0],
      setIsDone = _useState12[1];

  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var DefaultStyle = {
    alertColor: Theme["mlb-red"],
    progressColor: Theme["sky-blue"],
    barColor: Theme["mlb-blue"],
    color: "white",
    size: "25px"
  };

  var CompStyles = _objectSpread({}, DefaultStyle, {}, styles);

  var addZero = function addZero(val) {
    return val < 10 ? "0".concat(val) : val;
  };

  var isValid = function isValid(val) {
    return val && val.toString().trim() !== "00";
  };

  var calculate = function calculate() {
    var currentDate = new Date();
    var currentProgress = endDate.getTime() - currentDate.getTime();
    var totalProgress = endDate.getTime() - startDate.getTime();
    var progressPercent = currentProgress * 100 / totalProgress;

    if (progressPercent <= 0 || progressPercent > 100) {
      setIsDone(true);
    } else {
      setProgress(progressPercent);

      var _days = Math.floor(currentProgress / (1000 * 60 * 60 * 24));

      var _hours = Math.floor(currentProgress % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));

      var _minutes = Math.floor(currentProgress % (1000 * 60 * 60) / (1000 * 60));

      var _seconds = Math.floor(currentProgress % (1000 * 60) / 1000);

      setDays(addZero(_days));
      setHours(addZero(_hours));
      setMinutes(addZero(_minutes));
      setSeconds(addZero(_seconds));
    }
  };

  (0, _react.useEffect)(function () {
    var interval;

    if (startDate > endDate) {
      setIsDone(true);
    } else {
      interval = setInterval(calculate, 1000);
    }

    return function () {
      if (startDate < endDate) {
        clearInterval(interval);
      }
    };
  });
  return _react["default"].createElement(CountDownHolder, null, _react["default"].createElement(Bar, {
    styles: CompStyles
  }, !isDone ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(StyledIconHolder, null, (days || hours || minutes || seconds) && _react["default"].createElement(_Icon["default"], {
    iconName: "far fa-clock",
    className: "mr-2",
    styles: CompStyles
  })), _react["default"].createElement(Time, null, isValid(days) && _react["default"].createElement("span", null, days, ":"), isValid(hours) && _react["default"].createElement("span", null, hours, ":"), isValid(minutes) && _react["default"].createElement("span", null, minutes, ":"), seconds && _react["default"].createElement("span", null, seconds))) : "Done"), !isDone && _react["default"].createElement(Progress, {
    percent: progressPercent,
    styles: progressPercent < 15 ? CompStyles.alertColor : CompStyles.progressColor
  }));
};

CountdownClockProgressBar.defaultProps = {
  styles: {}
};
CountdownClockProgressBar.propTypes = {
  /** start date of the countdown */
  startDate: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].number, _propTypes["default"].instanceOf(_moment["default"])]).isRequired,

  /** end date of the countdown */
  endDate: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].number, _propTypes["default"].instanceOf(_moment["default"])]).isRequired,

  /** overrideable styles */
  styles: _propTypes["default"].shape({
    alertColor: _propTypes["default"].string,
    progressColor: _propTypes["default"].string,
    barColor: _propTypes["default"].string,
    color: _propTypes["default"].string,
    size: _propTypes["default"].string
  })
};
var _default = CountdownClockProgressBar;
exports["default"] = _default;